var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('nav',{staticClass:"navbar"},[_c('img',{staticClass:"nav-logo",attrs:{"src":require("../../assets/logo.png"),"title":"99Math","alt":"99Math"},on:{"click":_vm.redirectHome}})])])}
var staticRenderFns = []

export { render, staticRenderFns }